import {Component, ViewEncapsulation} from '@angular/core';
import {RouterModule} from '@angular/router';
import {ImagePathConstants, RoutesConstants} from "@coreconstant";
import {lastValueFrom} from 'rxjs';
import {FaqService} from 'src/app/core/services/api-service/faq.service';
import {ResponseHandlerService} from 'src/app/core/services/common-service/response-handler.service';
import {SeoService} from '../../core/services/common-service/seo.service';
import {SafeHtmlPipe} from 'src/app/core/pipes/safe-html.pipe';
import {WeddingPlanCtaComponent} from '../../core/component/common/wedding-plan-cta/wedding-plan-cta.component';
import {MetaDataConstants} from '../../core/constants/meta-data-constants';

@Component({
    selector: 'app-faqs',
    imports: [RouterModule, SafeHtmlPipe, WeddingPlanCtaComponent],
    templateUrl: './faqs.component.html',
    styleUrl: './faqs.component.scss',
    providers: [SafeHtmlPipe],
    encapsulation: ViewEncapsulation.None
})

export class FaqsComponent {
    routesConstants = RoutesConstants;
    imagePathConstants = ImagePathConstants;
    activeCategory: any = ''
    faqCategoriesAndData: any
    faqTypesAndData: any
    isGetResponse: boolean = false
    activeSection: string = '';

    constructor(
        private _faqService: FaqService,
        private _seoService: SeoService,
        private _responseHandlerService: ResponseHandlerService
    ) {
        this.setMetaTags()
    }

    /**
     * Initializes the component and its dependent processes.
     */
    ngOnInit() {
        this.getFaqData()
    }

    /**
     * Sets the meta tags for the current page by creating a meta tag object and passes it to the SEO service for application.
     * @return {void} Does not return a value.
     */
    setMetaTags() {
        let metaTagObject = {
            title: MetaDataConstants.HOW_IT_WORKS_FAQ.TITLE,
            description: MetaDataConstants.HOW_IT_WORKS_FAQ.DESCRIPTION,
            ogImageUrl: MetaDataConstants.HOW_IT_WORKS_FAQ.OGIMAGEURL,
            ogWebUrl: this.routesConstants.HOW_IT_WORKS_FAQS_NAVIGATION,
        }
        this._seoService.setMetaTags(metaTagObject)
    }

    /**
     * Fetches FAQ data by retrieving categories and their associated FAQs from the FAQ service.
     * @return {void} This method does not return anything directly, as it processes the data and updates the component's state.
     */
    getFaqData() {
        let getFaq = this._faqService.getCategoryFaq()
        lastValueFrom(getFaq).then((res: any) => {
            if (res["status"]) {
                const faqs = res["data"];
                this.faqCategoriesAndData = this.formatFaq(faqs)
                if (this.faqCategoriesAndData && this.faqCategoriesAndData[0] && this.faqCategoriesAndData[0].name)
                    this.toggleCategory(this.faqCategoriesAndData[0].name)

                this.isGetResponse = true
            }
        }, (error: any) => {
            this._responseHandlerService.handleAPIErrorResponse(error)
        });
    }

    /**
     * Formats and groups FAQs by category and type.
     * @param {Array<Object>} faqs - The list of FAQ categories, where each category contains its name and an array of FAQs.
     * Each FAQ includes information on its type.
     */
    formatFaq(faqs) {
        const data = faqs

        const groupedArray = data.map(category => {
            const categoryName = category.name;

            // Group FAQs by type
            const typeMap = category.faqs.reduce((typeAcc, faq) => {
                const typeName = faq.faqTypeInfo.name;
                const typeId = faq.faqTypeInfo.id

                if (!typeAcc[typeId]) {
                    typeAcc[typeId] = {
                        id: typeId,
                        name: typeName,
                        faqs: []
                    };
                }

                typeAcc[typeId].faqs.push(faq);
                return typeAcc;
            }, {});

            const typesArray = Object.values(typeMap);

            return {
                name: categoryName,
                types: typesArray
            };
        });
        return groupedArray
    }

    /**
     * Toggles the active category based on the provided category name.
     * @param {any} categoryName - The name of the category to set as active.
     */
    toggleCategory(categoryName: any) {
        let activecategory = this.activeCategory
        this.activeCategory = categoryName

        let filterData = this.faqCategoriesAndData.find((item: any) => item.name == categoryName);
        if (filterData) {
            this.faqTypesAndData = filterData.types
            if (activecategory != this.activeCategory) {
                this.scrollToSection('type' + filterData.types[0].id, filterData.name)
            }
        }
    }

    /**
     * Scrolls smoothly to the specified section of the page based on the section ID and adjusts for header offset.
     * @param {string} sectionId - The ID of the section to scroll to.
     */
    scrollToSection(sectionId: string, categoryName: string) {
        const section = document.getElementById(sectionId);
        const headerOffset =80;
        if (section) {
            const elementPosition = section.getBoundingClientRect().top + window.scrollY;
            console.log(elementPosition)
            const offsetPosition = elementPosition - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
        this.activeSection = sectionId;
    }
}
